<template>
	<div class="row contentblock">
		<div class="columns column6 col-image">
			<picture>
				<source :srcset="imageWebp" type="image/webp" />
				<source :srcset="image" />
				<img :src="image" :alt="imageAlt" loading="lazy" />
			</picture>
		</div>
		<div class="columns column6 col-content">
			<div class="contentblock-content">
				<div>
					<h3>{{ header }}</h3>
					<div v-parse-links v-html="content" />
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
defineProps({
	image: { type: String, default: '' },
	imageWebp: { type: String, default: '' },
	imageAlt: { type: String, default: '' },
	header: { type: String, default: '' },
	content: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.contentblock {
	display: flex;
	flex-flow: row-reverse wrap;
	align-items: stretch;
	padding: 0;
	margin: 1% auto;
	position: relative;
	gap: 1%;

	&:nth-child(odd) {
		flex-direction: row;

		.col-image {
			left: 0;
			right: auto;
		}
	}

	.columns {
		width: 49.5%;
		padding: 0;
		display: flex;
		flex-wrap: wrap;
		align-items: stretch;
	}

	img {
		object-fit: cover;
		width: 100%;
		height: 100%;
	}

	.col-content {
		position: relative;
		z-index: 2;
	}

	.contentblock-content {
		padding: 80px 50px;
		background: var(--primary-background-color);
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		width: 100%;
	}
}

@media (max-width: 1080px) {
	.contentblock {
		.col-image {
			width: 100%;
			position: relative;
		}

		.col-content {
			padding: 0;
			width: 100%;
			margin: 10px auto;
		}

		.contentblock-content {
			padding: 50px;
		}
	}
}

@media (max-width: 580px) {
	.contentblock {
		margin-bottom: 25px;

		.contentblock-content {
			padding: 35px;
		}
	}
}
</style>
